/* global initCookieConsent */
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import AnimOnScroll from './animOnScroll';
import 'sharer.js/sharer.js';

import '../scss/blog-application.scss';


$(function () {
	$(".c-hamburger").on('click', function (ev) {
		ev.preventDefault();
		if (this.classList.contains("is-active") === true) {
			this.classList.remove("is-active");
			//$('.page-content').removeClass('menuexpanded');
			$('header').removeClass('active');
			$('#main-menu').slideUp(200, function () {
			});
		} else {
			this.classList.add("is-active");
			//$('.page-content').addClass('menuexpanded');
			$('header').addClass('active');
			$('#main-menu').slideDown(function () {
			});
		}
	})
})

$(function () {
	function initMasonry() {
		if (!$('#masonry').length) return;

		var imgLoad = imagesLoaded('#masonry');
		imgLoad.on('progress', function (image, elem, message) {
			//$grid.reloadItems();
			//console.log("Progress: " + message);
		})
		imgLoad.on('fail', function () {
			console.log('all images loaded, at least one is broken');
		})
		imgLoad.on('always', function (instance) {
			console.log("Always: " + instance);
			var $grid = new Masonry('#masonry', {
				itemSelector: '.grid-item',
				percentPosition: true,
				columnWidth: '.grid-sizer',
				gutter: 0,
				transitionDuration: 0
			});
		});
	}

	initMasonry()
})


/* Back to top and Cookie buttons */
$(function () {

	$(document).scroll(function () {
		if ($('#back-to-top').hasClass('disabled')) return;
		if ($(window).scrollTop() > 150) {
			$('#back-to-top').fadeIn();
			/*$("#cookie-tab").fadeIn();*/
		} else {
			$('#back-to-top').fadeOut();
			/*$("#cookie-tab").fadeOut();*/
		}
	});

});

$(function () {

	$(window).scroll(function () {
		if ($(this).scrollTop() != 0) {
			if ($('.back-to-top').is(':visible')) return;
			$('.back-to-top').fadeIn(function () {
			});

		} else {
			$('.back-to-top').fadeOut();
		}
	});

	$('.back-to-top').click(function () {
		$('body,html').animate({ scrollTop: 0 }, 300);
	});
});

$(function () {
	setTimeout(function () {
		var visibleItems = $('#masonry').data('visible-items');
		$('#masonry .masonry-brick:lt(' + visibleItems + ')').delay(200).animate({ opacity: 1 }, function () {
			AnimOnScroll(document.getElementById('masonry'), {
				minDuration: 0.4,
				maxDuration: 0.7,
				viewportFactor: 0.2
			});
		});

	}, 0);
})

$(function () {
	$(".masonry-brick").on('click', function (ev) {
		if (!$(ev.target).is('a')) {
			ev.preventDefault();
			$(this).toggleClass('hover-effect');
		}

	})
})

$(function () {
	$("#main-menu .tags-container a").on("click", function (ev) {
		ev.preventDefault();

		$("#main-menu .tags-container a").not(this).removeClass("active")

		if ($(this).hasClass("active")) {
			$("#masonry .grid-item.grid-item-removed").css({ opacity: 0 }).show().addClass("animate")
			$("#masonry .grid-item").removeClass("animate grid-item-filtered grid-item-removed")
			
			
			var $grid = new Masonry('#masonry', {
				itemSelector: '.grid-item',
				percentPosition: true,
				columnWidth: '.grid-sizer',
				gutter: 0,
				transitionDuration: 2
			});

			var visibleItems = $('#masonry').data('visible-items');
			$('#masonry .masonry-brick:lt(' + visibleItems + ')').delay(200).animate({ opacity: 1 }, function () {
				AnimOnScroll(document.getElementById('masonry'), {
					minDuration: 0.4,
					maxDuration: 0.7,
					viewportFactor: 0.2
				});
			});

			$(this).removeClass("active");

		} else {
			var selectedTag = $(this).find("span").text();
			var articlesToHide = $("#masonry .grid-item").filter(function (index, el) {
				return $(el).data("tags").indexOf(selectedTag) == -1
			})

			var articlesToShow = $("#masonry .grid-item").filter(function (index, el) {
				return $(el).data("tags").indexOf(selectedTag) != -1
			})

			articlesToShow.fadeOut(300, function () {
				$(this).addClass("grid-item-filtered")
			})

			articlesToHide.fadeOut(300, function () {
				$(this).addClass("grid-item-removed")
			})

			setTimeout(function () {
				articlesToShow.show().addClass("animate").removeClass("grid-item-filtered");
				var $grid = new Masonry('#masonry', {
					itemSelector: '.grid-item',
					percentPosition: true,
					columnWidth: '.grid-sizer',
					gutter: 0,
					transitionDuration: 0
				});
			}, 500)

			$(this).addClass("active");
			
		}

		
		
	})
})